// extracted by mini-css-extract-plugin
export default {"buttonsDiv":"registerPage_buttonsDiv__qOh2U"};